<div class="videoContainer">
	<div class="singleVideoContainer">
		<sim-screen-container
			[isSingleView]="true"
			[cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer"
			[screenIndex]="screenIndexOverride ?? 0"
		/>
	</div>
</div>
